if (!window.FlikEnv || typeof window.FlikEnv != "object") {
  console.error("Flik env was not created");
}

var CHECKOUT_CANCEL = "/cart";
var CHECKOUT_FAIL = "/cart?status=fail";
var CHECKOUT_ICON =
  "https://cdn.shopify.com/s/files/1/0617/1633/2785/t/16/assets/flik-grey.png";
var CREATE_ORDER_ENDPOINT = "/api/cart";
var CREATE_FILK_ORDER = "/api/orders/create";
var CREATE_FILK_BUYNOW_ORDER = "/api/orders/buynow";
var SUCCESS_FILK_ORDER = "/api/orders/success";
var FLIK_PRODUCT = window.FLIK_PRODUCT || {};
var PREVIEW_THEME = Boolean(get_cookie("preview_theme")) || false;
var FINGERPRINTJS_URL = "https://cdn.jsdelivr.net/npm/@fingerprintjs/fingerprintjs@4.2.2/dist/fp.min.js";
var globalVisitorID = "";

if (PREVIEW_THEME) {
  console.log("window.FlikEnv:", window.FlikEnv);
}

var LOADING_OVERLAY_HTML = `
    <div class="flik-overlay">
        <div class="flik-loader">
            <div class="flik-dot"></div>
            <div class="flik-dot"></div>
            <div class="flik-dot"></div>
            <div class="flik-dot"></div>
            <div class="flik-dot"></div>
            <div class="flik-dot"></div>
            <div class="flik-dot"></div>
            <div class="flik-dot"></div>
        </div>
        <div class="flik-overlay-content">Your order's being processed.</div>
        <div class="flik-create-cart--stuck"></div>
    </div>
`;

var CART = {
  get: "/cart.js",
  clear: "/cart/clear",
};

// fetch cart and make cart_items ready for FLICK order generate
async function getCart() {
  var response = await fetch(CART.get, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.json();
}

async function createFlikOrder(cart) {
  var response = await fetch(FlikEnv.SERVER_URL + CREATE_FILK_ORDER, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      cart: cart,
      store_domain: FlikEnv.STORE_HANDLE,
      store_url: FlikEnv.STORE_BASE_URL,
      order_success_endpoint: FlikEnv.STORE_BASE_URL + FlikEnv.CHECKOUT_SUCCESS,
      order_fail_endpoint: FlikEnv.STORE_BASE_URL + CHECKOUT_FAIL,
      order_cancel_endpoint: FlikEnv.STORE_BASE_URL + CHECKOUT_CANCEL,
    }),
  });
  return response.json();
}

async function FlikBuyNowOrder(item) {
  var response = await fetch(FlikEnv.SERVER_URL + CREATE_FILK_BUYNOW_ORDER, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      item: item,
      store_domain: FlikEnv.STORE_HANDLE,
      store_url: FlikEnv.STORE_BASE_URL,
      order_success_endpoint: FlikEnv.STORE_BASE_URL + FlikEnv.CHECKOUT_SUCCESS,
      order_fail_endpoint: FlikEnv.STORE_BASE_URL + CHECKOUT_FAIL,
      order_cancel_endpoint: FlikEnv.STORE_BASE_URL + CHECKOUT_CANCEL,
    }),
  });
  return response.json();
}

function redirect(endpoint) {
  window.location.replace(endpoint);
}

function flikLoadingOverlay(state) {
  if (state === "hide") {
    document.querySelector(".flik-overlay").remove();
    document.querySelector("html").classList.remove("flik-overlay-scroll");
  } else {
    appendHTML(document.body, LOADING_OVERLAY_HTML, "beforeend");
    document.querySelector("html").classList.add("flik-overlay-scroll");
  }
}

function appendHTML(element, html, type = "afterBegin") {
  element.insertAdjacentHTML(type, html);
}

async function generateCartFLIK() {
  flikLoadingOverlay("show");
  try {
    await fieriFlikWithDeadline(fieriFlikClickPromise, 3000);
  } catch (error) {}
  createCart();
}

async function generateBuyNow() {
  if (this.dataset.actionType === "buy-now") {
    await getProductByHandler(this.dataset.flikHandle, this.dataset.variant)
  }
}

function flikInitCarts() {
  waitForElm('.fliK-checkout-block-cart').then((elm) => {
    const elms = document.querySelectorAll(`.fliK-checkout-block-cart button.flik-checkout`)
    if(elms.length > 0) {
      elms.forEach((elm) => {
        elm.addEventListener("click", amplitudeTrackCheckoutButton, false)
        elm.removeEventListener("click", generateCartFLIK, false)
        elm.addEventListener("click", generateCartFLIK, false)
      })
    }
  });
}

function flikInitQuickAdd() {
  const checkoutWrapper = document.querySelector(`.fliK-checkout-block-quick-add`)
  const checkoutBtn = document.querySelector(`.fliK-checkout-block-quick-add button.flik-checkout`)
  if (checkoutWrapper && checkoutBtn) {
    checkoutWrapper.addEventListener("click", async function (event) {
      if (this.dataset.actionType === "buy-now") {
        await getProductByHandler(this.dataset.flikHandle, this.dataset.variant)
      }
    }, false);
  }
}

function flikInitDetail() {
  const checkoutWrapper = document.querySelector(`.fliK-checkout-block-detail`)
  const checkoutBtn = document.querySelector(`.fliK-checkout-block-detail button.flik-checkout`)
  if (checkoutWrapper && checkoutBtn) {
    checkoutWrapper.addEventListener("click", async function (event) {
      if (this.dataset.actionType === "buy-now") {
        await getProductByHandler(this.dataset.flikHandle, this.dataset.variant)
      }
    }, false);
  }
}

function flikInitDetails() {
  const elms = document.querySelectorAll(`.fliK-checkout-block-detail button.flik-checkout`)
  if(elms.length > 0) {
    elms.forEach((elm) => {
      elm.removeEventListener("click", generateBuyNow, false)
      elm.addEventListener("click", generateBuyNow, false)
    })
  }
}

async function createCart() {
  console.log("order is being created via cart checkout");
  var cart = await getCart();
  setStatus();
  var order = await createFlikOrder(cart);
  if (PREVIEW_THEME) console.log("createFlikOrder:", order);
  if (order && order.cart_url) {
    let url = flikSetGA(order.cart_url)
    url = addUniqueId(url);
    document.querySelector(".flik-overlay-content").textContent =
      "Almost done!";
    appendHTML(
      document.querySelector(".flik-create-cart--stuck"),
      `<div class="flik-checkout-stuck">
                <a class="flik-btn-plain" href="${url}">Click here</a> if you are stuck
            </div>`
    );
    redirect(url);
    TrackIfStuck(url);
  } else {
    flikLoadingOverlay("hide");
  }
}

function FlikPrice(amount) {
  if (!amount || isNaN(amount)) {
    return 0;
  }
  if (typeof amount === "string") {
    try {
      amount = amount.replace(".", "");
    } catch (e) {}
  }
  if (amount && !isNaN(amount)) {
    try {
      amount = Number(amount) / 100;
    } catch (e) {}
  }
  return amount;
}

function setStatus() {
  setTimeout(() => {
    try {
      document.querySelector(".flik-overlay-content").textContent =
        "Checking inventories";
    } catch (e) {}
  }, 2000);
  setTimeout(() => {
    try {
      document.querySelector(".flik-overlay-content").textContent =
        "Almost done!";
    } catch (e) {}
  }, 10000);
  setTimeout(() => {
    try {
      flikLoadingOverlay("hide");
    } catch (e) {}
  }, 60000);
}

function TrackIfStuck(cart_url) {
  if (cart_url) {
    var i = 0;
    // recursive function to force user to go to checkout. Use recursive function to prevent infinite loop
    function _red() {
      i++;
      setTimeout(() => {
        redirect(cart_url);
        if (i < 20) {
          _red();
        }
      }, 1500);
    }
    _red();
  }
}

function get_cookie(cookie_name) {
  const value = "; " + document.cookie;
  const parts = value.split("; " + cookie_name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
}

function generateUniqueId() {
  return window.crypto.randomUUID().substring(0, 8);
}

function addUniqueId(urlStr) {
  let url = new URL(urlStr);
  url.searchParams.append("uqid", generateUniqueId());
  return url.toString();
}

async function getProductByHandler(handle, vid) {
  flikLoadingOverlay("show");
  await fetch(`${window.location.origin}/products/${handle}.json`)
  .then(async (response) => {
    const data = await response.json()
    FLIK_PRODUCT = data.product

    const selected_variant = FLIK_PRODUCT.variants.find((variant) => String(variant.id) === String(vid))
    if (PREVIEW_THEME) console.log("selected_variant", selected_variant)

    const dynamic_attributes = {
      option1: selected_variant.option1,
      option2: selected_variant.option2 === null ? undefined : selected_variant.option2,
      option3: selected_variant.option3 === null ? undefined : selected_variant.option3
    };

    var variant_qty_selector = document.querySelector('[name="quantity"]') || document.querySelector('[data-popout-toggle-text]');
    var variant_qty = 1;
    if (variant_qty_selector && (variant_qty_selector.value || variant_qty_selector.innerText)) {
      variant_qty = parseInt(variant_qty_selector.value) || parseInt(variant_qty_selector.innerText);
    }
    
    let imgUrl = FLIK_PRODUCT.image.src;
    if (PREVIEW_THEME) console.log("imgUrl:", imgUrl);

    const buy_now_product = [
      {
        product_id: String(FLIK_PRODUCT.id),
        item_id: String(vid),
        name: String(FLIK_PRODUCT.title),
        qty: variant_qty,
        dynamic_attributes: dynamic_attributes,
        weight: selected_variant.weight || 1,
        image_url: imgUrl,
        detail_url:
          FlikEnv.STORE_BASE_URL + "/products/" + FLIK_PRODUCT.handle,
        sell_price: FlikPrice(selected_variant.price),
        volume: {
          length: 5,
          width: 10,
          height: 5,
        },
      },
    ];
    if (PREVIEW_THEME) console.log("buy_now_product", buy_now_product);
    var order = await FlikBuyNowOrder(buy_now_product);
    if (PREVIEW_THEME) console.log("FlikBuyNowOrder : ", order);
    if (order && order.cart_url) {
      let url = flikSetGA(order.cart_url)
      url = addUniqueId(url);
      document.querySelector(".flik-overlay-content").textContent =
        "Almost done!";
      appendHTML(
        document.querySelector(".flik-create-cart--stuck"),
        `<div class="flik-checkout-stuck">
                        <a class="flik-btn-plain" href="${url}">Click here</a> if you are stuck
                    </div>`
      );
      redirect(url);
      TrackIfStuck(url);
    } else {
      flikLoadingOverlay("hide");
    }
  })
}

function flikVariantChange(selector, variant) {
  const elm = document.querySelector(selector)
  const pEmpty = document.querySelector(`.fliK-checkout-stock-empty`)

  if(elm && pEmpty) {
    elm.dataset.variant = variant.id

    if(!variant.available){
      elm.classList.add("isHidden")
      pEmpty.classList.remove("isHidden")
    } else {
      elm.classList.remove("isHidden")
      pEmpty.classList.add("isHidden")
    }
  }
}

function flikQuickAddVariantChange(root, selector, variant) {
  const elm = root.querySelector(selector)
  const pEmpty = root.querySelector(`.fliK-checkout-stock-empty`)

  if(elm && pEmpty) {
    elm.dataset.variant = variant.id

    if(!variant.available){
      elm.classList.add("isHidden")
      pEmpty.classList.remove("isHidden")
    } else {
      elm.classList.remove("isHidden")
      pEmpty.classList.add("isHidden")
    }
  }
}

function flikSetGA(url) {
  const cookiesGA = get_cookie(`_ga`)
  if(cookiesGA) {
    return `${url}?_gl=${cookiesGA}&back=${window.location.href}`;
  }
  return `${url}?back=${window.location.href}`
}

function waitForElm(selector) {
  return new Promise(resolve => {
      if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
              observer.disconnect();
              resolve(document.querySelector(selector));
          }
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

flikInitCarts();

var fieriFlikAnalyticsPromise = null;
var fieriFlikClickPromise = Promise.resolve();
var fieriFlikAnalyticsNode = document.currentScript;
var fieriFlikDependencyPromises = new Map();

function isAmplitudeEnabled() {
  return Boolean(FlikEnv.AMPLITUDE_KEY);
}

function fieriFlikStatus(value) {
  if (fieriFlikAnalyticsNode) fieriFlikAnalyticsNode.dataset.analyticsState = value;
}

function fieriFlikDependency(url, integrity) {
  if (fieriFlikDependencyPromises.has(url)) return fieriFlikDependencyPromises.get(url);
  var work = new Promise(function(resolve, reject) {
    var script = document.createElement('script');
    var timer = setTimeout(function() { reject(new Error('FLIK analytics dependency timeout')); }, 5000);
    script.src = url;
    script.async = true;
    if (integrity) {
      script.integrity = integrity;
      script.crossOrigin = 'anonymous';
    }
    script.onload = function() { clearTimeout(timer); resolve(); };
    script.onerror = function() { clearTimeout(timer); reject(new Error('FLIK analytics dependency unavailable')); };
    document.head.appendChild(script);
  });
  fieriFlikDependencyPromises.set(url, work);
  return work;
}

function fieriFlikWithDeadline(work, duration) {
  return new Promise(function(resolve, reject) {
    var timer = setTimeout(function() { reject(new Error('FLIK analytics readiness timeout')); }, duration);
    Promise.resolve(work).then(function(value) { clearTimeout(timer); resolve(value); }, function(error) { clearTimeout(timer); reject(error); });
  });
}

function fieriFlikEnsureAnalytics() {
  if (!isAmplitudeEnabled()) return Promise.resolve();
  if (fieriFlikAnalyticsPromise) return fieriFlikAnalyticsPromise;
  fieriFlikStatus('loading');
  var amplitudeWork = window.amplitude && typeof window.amplitude.init === 'function'
    ? Promise.resolve()
    : fieriFlikDependency('https://cdn.amplitude.com/libs/analytics-browser-2.7.2-min.js.gz', 'sha384-G0XMXkK/sz1YcpLlDH0wrm+5iZ5exY1bsy8oL+VbZkOXU9ajThA5ma7ngHQmlG7A');
  amplitudeWork = amplitudeWork.then(function() {
    return fieriFlikWithDeadline(amplitude.init(FlikEnv.AMPLITUDE_KEY, { defaultTracking: false }).promise, 5000);
  });
  var visitorWork = (window.FingerprintJS ? Promise.resolve() : fieriFlikDependency(FINGERPRINTJS_URL)).then(function() {
    return fieriFlikWithDeadline(FingerprintJS.load().then(function(fp) { return fp.get(); }), 5000);
  }).then(function(result) { globalVisitorID = result.visitorId; });
  fieriFlikAnalyticsPromise = Promise.all([amplitudeWork, visitorWork]).then(function() {
    fieriFlikStatus('ready');
  }, function(error) {
    fieriFlikStatus('failed');
    throw error;
  });
  return fieriFlikAnalyticsPromise;
}

function getPageTitle() {
  return document.querySelector('title').innerText.trim().replaceAll('\n', '');
}

function amplitudeTrackCheckoutButton() {
  if (!isAmplitudeEnabled()) return;
  var properties = {
    platform: 'web',
    button_name: 'Checkout Button',
    button_variant: FlikEnv.STORE_NAME,
    button_sub_variant: 'Platform',
    page_name: getPageTitle(),
    button_clicked_at: Date.now(),
    user_id: 'anonymous',
    device_id: globalVisitorID
  };
  fieriFlikClickPromise = fieriFlikEnsureAnalytics().then(function() {
    properties.device_id = globalVisitorID;
    return amplitude.track('Button Clicked', properties).promise;
  }).then(function() {
    return amplitude.flush().promise;
  });
  fieriFlikClickPromise.catch(function() { fieriFlikStatus('failed'); });
}

function fieriFlikWarmAnalytics(event) {
  if (!event.target || typeof event.target.closest !== 'function') return;
  if (!event.target.closest('#cart-icon-bubble, cart-drawer, .fliK-checkout-block-cart, .fliK-checkout-block-quick-add')) return;
  fieriFlikEnsureAnalytics().catch(function() {});
}

fieriFlikStatus(isAmplitudeEnabled() ? 'idle' : 'disabled');
document.addEventListener('pointerdown', fieriFlikWarmAnalytics, { passive: true, capture: true });
document.addEventListener('keydown', fieriFlikWarmAnalytics, { capture: true });
document.addEventListener('focusin', fieriFlikWarmAnalytics, { capture: true });
document.addEventListener('pointerover', fieriFlikWarmAnalytics, { passive: true, capture: true });
